import { render, staticRenderFns } from "./ExportDES.vue?vue&type=template&id=22528fc0&"
import script from "./ExportDES.vue?vue&type=script&lang=js&"
export * from "./ExportDES.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports